<template>
  <div class="box-container">
    <img :src="'https://res.ponhu.cn/online/blindbox/box_max_'+temp+'_01.jpg'" alt="">
    <img :src="'https://res.ponhu.cn/online/blindbox/box_max_'+temp+'_02.jpg'" alt="">
    <div class="goods-item">
      <img :src="'https://res.ponhu.cn/online/blindbox/box_max_'+temp+'_03.jpg'" alt="">
      <div class="btn" @click="createOrder"></div>
    </div>
    <img :src="'https://res.ponhu.cn/online/blindbox/box_max_'+temp+'_04.jpg'" alt="">
    <img :src="'https://res.ponhu.cn/online/blindbox/box_max_'+temp+'_05.jpg'" alt="">
    <img :src="'https://res.ponhu.cn/online/blindbox/box_max_'+temp+'_06.jpg'" alt="">
  </div>
</template>

<script>
import { getWxUrl } from '@/api/order'
import { BrowserInfo } from '@/utils'
import wxapi from '@/utils/wxApi'

export default {
  data() {
    return {
      temp: '',
      goods_id: 0,
      channel_id: 34,
      sale_id: 0
    }
  },
  created () {
    this.temp = this.$route.params.price;
    this.goods_id = this.$route.query.gid;
    this.sale_id = this.$route.query.sid;
    wxapi.wxRegister(this.wxRegCallback)
  },
  methods: {
    // 创建订单
    createOrder() {
      // 清理结算缓存
      this.$store.dispatch('OnlineBalanceOut')
      let url = '/online/settlement/goods?channel='+this.channel_id+'&sale='+this.sale_id
      if (BrowserInfo().isWeixin) {
        getWxUrl({ url: url, label: 1 }).then(res => {
          location.href = res
        })
      } else {
        this.$router.push({ path: '/online/settlement/goods?channel='+this.channel_id+'&sale='+this.sale_id })
      }
    },
    // 微信注册
    wxRegCallback () {
      // 微信分享
      this.wxShareTimeline()
      this.wxShareAppMessage()
    },
    wxShareTimeline () {
      let _this = this
      let option = {
        title: '胖虎超值盲盒',
        link: process.env.VUE_APP_ROOT_URL + 'index.html#/online/blindbox',
        imgUrl: 'https://res.ponhu.cn/new/logo200_200.jpg',
        success: () => {
          _this.$toast('分享成功')
        },
        error: () => {
          _this.$toast('已取消分享')
        }
      }
      // 将配置注入通用方法
      wxapi.ShareTimeline(option)
    },
    wxShareAppMessage () {
      let _this = this
      let option = {
        title: '胖虎超值盲盒',
        desc: '开箱有惊喜，大牌好货应有尽有！',
        link: process.env.VUE_APP_ROOT_URL + 'index.html#/online/blindbox',
        imgUrl: 'https://res.ponhu.cn/new/logo200_200.jpg',
        success: () => {
          _this.$toast('分享成功')
        },
        error: () => {
          _this.$toast('已取消分享')
        }
      }
      // 将配置注入通用方法
      wxapi.ShareAppMessage(option)
    }
  }
}
</script>

<style lang="less" scoped>
.box-container {
  img{
    display: block;
    width: 100%;
    border: none;
    outline: none;
  }
  .goods-item {
    position: relative;
    .btn {
      position:absolute;
      width: 7rem;
      height: 1.3rem;
      bottom: 0.4rem;
      left: 1.4rem;
      z-index: 10000;
    }
  }
}
</style>



